<template>
  <div>
    <h3>{{ company.name }}</h3>
    <div class="d-flex no-print">
      <button class="no-print" @click="fetchDoubtfulDebtors">Zoeken</button>
      <button class="no-print" @click="resetData">Reset</button>
      <button class="no-print" @click="print">Afdrukken</button>
      <button class="no-print" @click="exportToExcel">Excel</button>
      <search-client
        class="search-client"
        :searchString="searchString"
        @setSearchString="setSearchString"
        @get-results="setClientNumber"
        @clear-input="clearClientNumber"
      ></search-client>
    </div>
    <b>Totaal afgeschreven: {{ toCurrency(grandTotal) }}</b>
    <div
      class="d-flex justify-center block"
      v-for="object of debtorsArray"
      :key="object._id"
    >
      <table>
        <tr>
          <th>Klantnr</th>
          <th>Naam</th>
          <th>Adres</th>
          <th>Postcode</th>
          <th>Plaats</th>
          <th>Telefoon</th>
          <th>Factuurnr</th>
          <th>Datum</th>
          <th>Bedrag</th>
          <th>Afgeschreven</th>
          <th>Opmerking</th>
        </tr>
        <tr v-for="invoice of object.invoices" :key="invoice._id">
          <td>{{ object._id }}</td>
          <td>{{ object.name }}</td>
          <td>{{ object.client && object.client.address }}</td>
          <td>{{ object.client && object.client.postalcode }}</td>
          <td>{{ object.client && object.client.city }}</td>
          <td>{{ object.client && object.client.phone }} | {{ object.client && object.client.mobile }}</td>
          <td>{{ invoice.invoiceNumber }}</td>
          <td>{{ new Date(invoice.date).toLocaleDateString('NL') }}</td>
          <td>{{ toCurrency(invoice.grossTotal) }}</td>
          <td>{{ toCurrency(invoice.dubDebAmount) }}</td>
          <td>{{ invoice.dubDebDescription }}</td>
        </tr>
        <tr>
          <td colspan="9"></td>
          <td><b>Totaal:</b></td>
          <td><b>{{ toCurrency(object.totalWrittenOff) }}</b></td>
        </tr>
      </table>
      <hr />
    </div>
  </div>
</template>

<script>
import { fetchGET, toCurrency } from '../js/functions'
import * as XLSX from 'xlsx'
import searchClient from '@/components/searchClient.vue'

export default {
  name: 'doubtfulDebtors',
  data() {
    return {
      debtorsArray: [],
      searchString: '',
      clientNumber: 0
    }
  },
  methods: {
    async fetchDoubtfulDebtors() {
      this.debtorsArray = await fetchGET('fetchDoubtfulDebtors', {
        clientNumber: this.clientNumber || undefined
      })
    },
    resetData() {
      this.debtorsArray = []
      this.searchString = ''
      this.clientNumber = 0
    },
    print() {
      window.print()
    },
    exportToExcel() {
      let rows = []
      for (let group of this.debtorsArray) {
        for (let inv of group.invoices) {
          rows.push({
            Klantnr: group._id,
            Naam: group.name,
            Adres: group.client && group.client.address,
            Postcode: group.client && group.client.postalcode,
            Plaats: group.client && group.client.city,
            Telefoon: group.client && group.client.phone,
            Factuurnr: inv.invoiceNumber,
            Datum: new Date(inv.date).toLocaleDateString('NL'),
            Bedrag: inv.grossTotal,
            Afgeschreven: inv.dubDebAmount,
            Opmerking: inv.dubDebDescription
          })
        }
      }
      let ws = XLSX.utils.json_to_sheet(rows)
      let wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Dubieuze Debiteuren')
      XLSX.writeFile(wb, 'dubieuze_debiteuren.xlsx')
    },
    toCurrency(val) {
      return toCurrency(val)
    },
    setSearchString(val) {
      this.searchString = val
    },
    async setClientNumber(val) {
      this.clientNumber = val.clientNumber
      await this.fetchDoubtfulDebtors()
    },
    clearClientNumber() {
      this.searchString = ''
      this.clientNumber = 0
    }
  },
  computed: {
    grandTotal() {
      return this.debtorsArray.reduce((acc, cur) => acc + (cur.totalWrittenOff || 0), 0)
    },
    company() {
      return this.$store.state.settings.company
    }
  },
  components: {
    searchClient
  },
  mounted() {
    this.fetchDoubtfulDebtors()
  }
}
</script>

<style scoped>
input {
  background: white;
}

button {
  width: 120px;
  height: 50px;
  background: #c0392b;
  color: white;
  border: none;
  cursor: pointer;
  margin-right: 8px;
}

button:hover {
  background: #a93226;
}

.block {
  background: white;
}

th,
td {
  text-align: left;
  width: 150px;
  padding: 4px 8px;
}

hr {
  width: 100%;
  margin: 8px 0;
}

b {
  display: block;
  margin: 12px 0;
  font-size: 1.1em;
}
</style>
